<template>
  <div>
    <div class="bg-section">
      <v-col
        lg="5"
        sm="10"
      >
        <v-card class="elevation-10">
          <v-btn
            fab
            elevation="0"
            color="transparent"
            small
            class="close-button"
            @click="deviceLogout()"
          >
            <v-icon color="#37474F">
              mdi-logout
            </v-icon>
          </v-btn>
          <v-card-text>
            <div class="pl-10 pt-10 pb-10 pr-10">
              <img
                width="100px"
                src="../../../../assets/img/swift-checkin-ezybuild-logo.png"
                alt=""
              >
              <br><br>
              <div class="pt-10">
                <h1>
                  <v-icon color="#101010">
                    mdi-human-greeting
                  </v-icon> Welcome !
                </h1>
                <br>
                <p>
                  <font class="company-text-style">
                    {{ deviceData.organization_id.name }}
                  </font>
                </p>
                <p>{{ deviceData.name }}</p>
                <br>
              </div>
              <div class="button-group">
                <v-btn
                  class="checkin-btn"
                  @click="toUserListPage('checkin')"
                >
                  check-in
                </v-btn>
                <v-btn
                  class="checkout-btn"
                  @click="toUserListPage('checkout')"
                >
                  check-out
                </v-btn>
              </div>
              <br><br><br>
              <p class="date-text-style">
                {{ realDate }}
              </p>
              <p class="clock-text-style">
                {{ realTimeClock }}
              </p>
              <p class="text-right">
                © copyright 2024 by Dibasys
              </p>
            </div>
          </v-card-text>
        </v-card>
        <br>
        <br>
        <br>
      </v-col>
    </div>
    <centre-spinner :loading="loading" />
  </div>
</template>

<script>
import moment from 'moment';
import spinner from '../../../components/SpinnerCentre.vue';
import Constants from 'src/constants';
export default {
  name: 'CheckInCheckOutPage',
  components: {
    'centre-spinner': spinner,
  },
  data () {
    return {
      loading: false,
      realDate: moment().format('DD/MM/YYYY'),
      realTimeClock: '',
      clockInterval: null,
      device: {},
    };
  },
  computed: {
    deviceData () {
      return this.$store.getters.getDeviceData;
    },
  },
  mounted () {
    this.loading = true;
    this.checkUserExist();
    this.loading = false;
  },
  beforeDestroy () {
    clearInterval(this.clockInterval);
  },
  methods: {
    async checkUserExist () {
      this.device = localStorage.getItem('device');
      if (this.device === null) {
        this.$router.push({ name: 'DeviceLogin' });
        return;
      }
      this.loading = true;
      await this.updateClock();
      this.clockInterval = await setInterval(this.updateClock, 1000);
      await this.$store.dispatch('kioskUserLogout');
      await this.$store.dispatch('devices/saveCheckOutMethod', '');
      this.loading = false;
    },
    async toUserListPage (val) {
      await this.$store.dispatch('devices/saveCheckInDetails', val);
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'DeviceSelectUser' });
      }, 1000);
    },
    updateClock () {
      this.realTimeClock = moment().format('hh : mm : ss A');
    },
    async deviceLogout () {
      this.loading = true;
      await this.$store.dispatch('clearWorkerTokenAndAssignKioskToken');
      try {
        await this.$store.dispatch('devices/logout');
        await this.$store.dispatch('alert/onAlert', {
            message: 'Kiosk Log out Successful.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
        await this.$store.dispatch('deviceLogout');
        await this.$router.push('/device');
      } catch (error) {
        await this.$store.dispatch('deviceLogout');
        await this.$router.push('/device');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.bg-section {
  width: 100%;
  height: 100vh;
  display: flex;
  overflow-y: auto;
  justify-content: center;
  align-items: center;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.781)), url('../../../../assets/img/welcome-bg.jpg');
  background-size: cover;
  background-position: center;
}

.bg-section::-webkit-scrollbar {
  display: none;
}

.company-text-style {
  background: rgb(255, 166, 0);
  background: linear-gradient(295deg, rgb(255, 123, 0) 0%, rgba(255, 55, 0, 1) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: larger;
  font-weight: bold;
}

.checkin-btn {
  border-radius: 100px;
  width: 200px;
  height: 50px !important;
}

.checkout-btn {
  border-radius: 100px;
  width: 200px;
  height: 50px !important;
}

.date-text-style {
  color: rgb(255, 255, 255);
}

.clock-text-style {
  font-size: 2em;
  font-weight: bolder;
  font-family: Arial, sans-serif;
  color: rgb(255, 255, 255);
}

.v-card {
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.582);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.445);
}

.v-card__text {
  padding: 0px;
}

.bg-image {
  background-image: url("../../../../assets/img/welcome-bg.jpg");
  background-size: cover;
  background-position: center;
}

@media (max-width: 900px) {
  .bg-image {
    display: none;
  }

  .clock-text-style {
    font-size: 25px;
  }
}

.button-group {
  display: flex;
  gap: 20px;
}
</style>
